import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './miscellaneousActionType';
import * as actions from './miscellaneousActions';
import * as services from './miscellaneousService';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';


//------------------ Miscellaneous Site Data - start------------------//
function* fetchMiscSiteDataSaga(action) {
    try {
        const response = yield call(services.getAllMiscSiteData, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        if (response.success) {
            yield put(actions.fetchMiscSiteDataSuccess(response?.values));
        } else {
            throw new Error(response.errorMessage || 'Failed to fetch miscellaneous site data');
        }
    } catch (error) {
        let errorMessage = error.message || 'Failed to fetch miscellaneous site data.';
        console.error('Miscellaneous Site Data API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchMiscSiteDataFailure(errorMessage));
    }
}

function* fetchSitesDropdownSaga() {
    try {
        const response = yield call(services.getAllSitesDropdown);
        if (!response) {
            throw new Error('No response received from API');
        }
        if (response.success) {
            yield put(actions.fetchSitesDropdownSuccess(response?.values?.dropdownItems || []));
        } else {
            throw new Error(response.errorMessage || 'Failed to fetch sites dropdown');
        }
    } catch (error) {
        let errorMessage = error.message || 'Failed to fetch sites dropdown.';
        console.error('Sites Dropdown API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchSitesDropdownFailure(errorMessage));
    }
}

function* fetchPracticeSiteMappingSaga(action) {
    try {
        const siteID = action.payload;
        const response = yield call(services.getPracticeSiteMappingBySiteID, siteID);
        if (!response) {
            throw new Error('No response received from API');
        }
        if (response.success) {
            yield put(actions.fetchPracticeSiteMappingSuccess(response?.values));
        } else {
            throw new Error(response.errorMessage || 'Failed to fetch practice site mapping');
        }
    } catch (error) {
        let errorMessage = error.message || 'Failed to fetch practice site mapping.';
        console.error('Practice Site Mapping API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchPracticeSiteMappingFailure(errorMessage));
    }
}

function* saveUpdateMiscSitesSaga(action) {
    try {
        const payload = action.payload;
        const response = yield call(services.saveUpdateMiscSitesList, payload);

        if (!response) {
            throw new Error('No response received from API');
        }

        // Check for various success indicators
        if (response.success === true || response.status === 'success') {
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Updated successfully.'
            });

            yield put(actions.saveUpdateMiscSitesSuccess(response?.values || response?.data || response));
        } else {
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to save miscellaneous sites data'
            });
        }
    } catch (error) {
        let errorMessage = error.message || 'Failed to save miscellaneous sites data.';
        yield put(actions.saveUpdateMiscSitesFailure(errorMessage));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to save miscellaneous sites data'
        });
    }
}
//------------------ Miscellaneous Site Data - end------------------//


export default function* watchMiscellaneousSaga() {
    yield takeEvery(types.FETCH_MISC_SITE_DATA_REQUEST, fetchMiscSiteDataSaga);
    yield takeEvery(types.FETCH_SITES_DROPDOWN_REQUEST, fetchSitesDropdownSaga);
    yield takeEvery(types.FETCH_PRACTICE_SITE_MAPPING_REQUEST, fetchPracticeSiteMappingSaga);
    yield takeEvery(types.SAVE_UPDATE_MISC_SITES_REQUEST, saveUpdateMiscSitesSaga);
}